function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import CatalogObjectSerializer from '@square/dashboard-items-data/serializers/connect/catalog-object';
export default class Category extends CatalogObjectSerializer {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "attrs", {
      images: {
        serialize: 'ids',
        deserialize: 'ids',
        serializedOnFragment: 'category_data',
        serializedOnKey: 'image_ids'
      },
      parentCategory: {
        serialize: 'id',
        deserialize: 'id',
        serializedOnFragment: 'category_data',
        serializedOnKey: 'parent_category_id'
      },
      availabilityPeriods: {
        serialize: 'ids',
        deserialize: 'ids',
        serializedOnFragment: 'category_data',
        serializedOnKey: 'availability_period_ids'
      }
    });
  }
  normalize(type, category) {
    const parentCategory = category.category_data?.parent_category;
    if (parentCategory) {
      // creating a new variable on the category data to use it
      // as a relationship on the category model
      category.category_data.parent_category_id = parentCategory.id;
    }
    if (category.category_data) {
      category.category_data.channels = category.category_data.channels ?? [];
      category.category_data.ecom_seo_data = {
        page_description: category.category_data.ecom_seo_data?.page_description ?? '',
        page_title: category.category_data.ecom_seo_data?.page_title ?? '',
        permalink: category.category_data.ecom_seo_data?.permalink ?? ''
      };
      category.category_data.open_graph_data = {
        link_description: category.category_data.open_graph_data?.link_description ?? '',
        link_title: category.category_data.open_graph_data?.link_title ?? ''
      };
    }
    const normalizedDocument = super.normalize(type, category);
    if (category.category_data?.path_to_root) {
      normalizedDocument.included = normalizedDocument.included || [];
      const normalizedPathItems = category.category_data.path_to_root.map(pathItem => {
        const normalizedPathItem = {
          id: pathItem.category_id,
          type: 'connect/category/path-to-root-category',
          attributes: {
            categoryName: pathItem.category_name
          }
        };
        return normalizedPathItem;
      });
      normalizedDocument.included = [...normalizedDocument.included, ...normalizedPathItems];
      normalizedDocument.data.relationships.pathToRoot = {
        data: category.category_data.path_to_root.map(pathItem => {
          return {
            id: pathItem.category_id,
            type: 'connect/category/path-to-root-category'
          };
        })
      };
    }
    return normalizedDocument;
  }
  serialize(snapshot, options) {
    const json = super.serialize(snapshot, options);
    // delete counts from json
    delete json.category_data.item_count;
    delete json.category_data.category_count;

    // The UI only changes parentCategory relationship which is serialized
    // to parent_category_id. Here we check if the updated parent category
    // is the same as the original
    const updatedParentCategory = json.category_data.parent_category_id;
    const originalParentCategory = json.category_data.parent_category;
    if (updatedParentCategory !== originalParentCategory?.id) {
      if (!updatedParentCategory) {
        if (originalParentCategory?.id) {
          delete json.category_data.parent_category;
        }
      } else {
        if (updatedParentCategory) {
          json.category_data.parent_category = {
            id: updatedParentCategory
          };
        }
      }
    }
    if (json.channels) {
      json.category_data.channels = json.channels;
      delete json.channels;
    }
    delete json.category_data.parent_category_id;
    return json;
  }
}